<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDraggable_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M10.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10.5 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15.5 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
</svg>
